<kt-portlet>
    <kt-portlet-header [title]="getComponentTitle()"
                       [tooltipTitle]="'TOOLTIP.ASSIGNMENT.FORM'+(assignment && assignment.id > 0 ? '_EDIT':'')+'.TITLE' | translate"
                       [tooltipDesc]="'TOOLTIP.ASSIGNMENT.FORM'+(assignment && assignment.id > 0 ? '_EDIT':'')+'.DESCRIPTION' | translate"
                       [class]="'kt-portlet__head--lg'" [viewLoading$]="loading$">
        <ng-container ktPortletTools>


            <a href="javascript:;"
               (click)="back()"
               class="btn mr-2"
               mat-raised-button
               [matTooltip]="'GENERAL.TOOLTIP.BACK' | translate:{back_page: ('ASSIGNMENT.LIST.TITLE' | translate)} ">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">{{'GENERAL.BUTTON.BACK' | translate}}</span>
            </a>
            <a href="javascript:;" class="btn btn-success mr-2" color="submit"
                *ngIf="!readonly"
               (click)="onSubmit()"
               [disabled]="!isFormValid()"
               mat-raised-button [matTooltip]="'GENERAL.TOOLTIP.SAVE' | translate">
                <span class="kt-hidden-mobile">{{'GENERAL.BUTTON.SAVE' | translate}}</span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <form class="kt-form" *ngIf="isExistAss| async" [formGroup]="assignmentForm" [ngClass]="{'readonly': readonly}">
            <div class="kt-portlet__body">

                <!--<div class="kt-portlet__body-progress">-->
                    <!--<mat-spinner [diameter]="20"></mat-spinner>-->
                <!--</div>-->

                <!-- <kt-alert *ngIf="hasFormErrors" type="warn" [duration]="30000" [showCloseButton]="true" (close)="onAlertClose($event)">
                    {{'GENERAL.MESSAGE.FORM_WARNING' | translate}}
                </kt-alert> -->

                <div class="form-group kt-form__group row">
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="assignmentForm.controls['name']">
                            <input matInput
                                   [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.NAME.PLACEHOLDER' | translate"
                                   formControlName="name"/>
                            <mat-hint [formFieldHintState]="assignmentForm.controls['name']">
                                Assignment ID <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('ASSIGNMENT.FORM.FIELD.GENERAL.NAME.NAME' | translate)}"
                            >
                            </mat-error>

                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <span (click)="picker.open()">
                            <input matInput [matDatepicker]="picker"
                                   [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.INSERTION_DATE.PLACEHOLDER' | translate"
                                   formControlName="insertion_date"/>
                            </span>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="assignmentForm.controls['valuer_id']">
                            <mat-select [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.VALUER.PLACEHOLDER' | translate"
                                        formControlName="valuer_id">
                                <mat-option *ngFor="let valuer of valuers" [value]="valuer.id">{{valuer.full_name}}</mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="assignmentForm.controls['valuer_id']">
                                Project Manager <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('ASSIGNMENT.FORM.FIELD.GENERAL.VALUER.NAME' | translate)}"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="assignmentForm.controls['agency_id']">
                            <mat-select [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.AGENCY.PLACEHOLDER' | translate"
                                        formControlName="agency_id">
                                <mat-option *ngFor="let agency of agencies" [value]="agency.id">{{agency.name}}</mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="assignmentForm.controls['agency_id']">
                                Agency <span>required</span>
                            </mat-hint>
                            <mat-error
                                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{field: ('ASSIGNMENT.FORM.FIELD.GENERAL.AGENCY.NAME' | translate)}"
                            >
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group kt-form__group row">
                    <div class="col-md-12 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="assignmentForm.controls['pointOfContact']">
                            <textarea matInput rows="4"
                                      [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.POINT_OF_CONTACT.PLACEHOLDER' | translate"
                                      formControlName="pointOfContact"
                            ></textarea>
                            <mat-icon
                                    matSuffix
                                    class="cursor-pointer"
                                    container="body"
                                    (click)="$event.stopPropagation();"
                                    [ngbPopover]="'TOOLTIP.ASSIGNMENT.FORM_FIELD.POINT_OF_CONTACT.DESCRIPTION' | translate"
                                    [popoverTitle]="'TOOLTIP.ASSIGNMENT.FORM_FIELD.POINT_OF_CONTACT.TITLE' | translate">help
                            </mat-icon>
                            <mat-hint [formFieldHintState]="assignmentForm.controls['pointOfContact']">
                                Point of Contact <span>required</span>
                            </mat-hint>
                            <mat-error>
                                Point of Contact <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="assignmentForm.controls['description']">
                            <textarea matInput rows="4"
                                      [placeholder]="'ASSIGNMENT.FORM.FIELD.GENERAL.DESCRIPTION.PLACEHOLDER' | translate"
                                      formControlName="description"
                            >
                            </textarea>
                            <mat-icon
                                    matSuffix
                                    class="cursor-pointer"
                                    (click)="$event.stopPropagation();"
                                    container="body"
                                    [ngbPopover]="'TOOLTIP.ASSIGNMENT.FORM_FIELD.DESCRIPTION.DESCRIPTION' | translate"
                                    [popoverTitle]="'TOOLTIP.ASSIGNMENT.FORM_FIELD.DESCRIPTION.TITLE' | translate">help
                            </mat-icon>
                            <mat-hint [formFieldHintState]="assignmentForm.controls['description']">
                                Description <span>required</span>
                            </mat-hint>
                            <mat-error>
                                Description <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </kt-portlet-body>
</kt-portlet>